/* Auto-built from oxyStaking.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "getCurrentCycle",
    title: "Get Current Cycle",
    description: "Read `getCurrentCycle` from the contract",
    icon: "⏱️",
    category: "Staking",
    inputs: [],
  },
  {
    name: "getOxyPriceInUsdt",
    title: "Get OXY Price In USDT",
    description: "Read `getOxyPriceInUsdt` from the contract",
    icon: "💲",
    category: "Economics",
    inputs: [
      { name: "oxyAmount", type: "uint256", label: "OXY Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getRewardCycleInfo",
    title: "Get Reward Cycle Info",
    description: "Read `getRewardCycleInfo` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [
      { name: "cycle", type: "uint256", label: "Cycle", placeholder: "Enter cycle", required: true },
    ],
    formatOutput: (v) => [
      `Total Staked_: ${fmt.amount(v.totalStaked_ ?? v[0])}`,
      `Reward Balance: ${fmt.amount(v.rewardBalance ?? v[1])}`,
    ].join("\n"),
  },
  {
    name: "getUserStakeCount",
    title: "Get User Stake Count",
    description: "Read `getUserStakeCount` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getUserStakes",
    title: "Get User Stakes",
    description: "Every stake position owned by an account.",
    icon: "🔒",
    category: "Staking",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) =>
      (v || []).length === 0
        ? "None"
        : v
            .map((row, i) =>
              [
                `#${i}`,
                `  Amount: ${fmt.amount(row.amount)}`,
                `  Start Time: ${fmt.time(row.startTime)}`,
                `  Last Cycle: ${row.lastCycle}`,
                `  Reward Claimed: ${fmt.amount(row.rewardClaimed)}`,
                `  Accrued Reward: ${fmt.amount(row.accruedReward)}`,
                `  Claim Cycle: ${row.claimCycle}`,
                `  Claimed In Cycle: ${row.claimedInCycle}`,
                `  Burned Amount: ${fmt.amount(row.burnedAmount)}`,
                `  Closed: ${fmt.bool(row.closed)}`,
              ].join("\n")
            )
            .join("\n\n"),
  },
  {
    name: "globalCycle",
    title: "Global Cycle",
    description: "Read `globalCycle` from the contract",
    icon: "⏱️",
    category: "Timing",
    inputs: [],
  },
  {
    name: "globalLastDraw",
    title: "Global Last Draw",
    description: "Read `globalLastDraw` from the contract",
    icon: "🔹",
    category: "Timing",
    inputs: [],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "globalMarketPlaceReward",
    title: "Global Market Place Reward",
    description: "Read `globalMarketPlaceReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "globalMatrixReward",
    title: "Global Matrix Reward",
    description: "Read `globalMatrixReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "isStakingOpen",
    title: "Is Staking Open",
    description: "Read `isStakingOpen` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "maxClaimAmount",
    title: "Max Claim Amount",
    description: "Read `maxClaimAmount` from the contract",
    icon: "🎁",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "oxyToken",
    title: "OXY Token",
    description: "Read `oxyToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "nftMarketPlace",
    title: "NFT Market Place",
    description: "Read `nftMarketPlace` from the contract",
    icon: "🛒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nftMatrix",
    title: "NFT Matrix",
    description: "Read `nftMatrix` from the contract",
    icon: "🌳",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "pair",
    title: "Pair",
    description: "Read `pair` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "pendingReward",
    title: "Pending Reward",
    description: "Reward that has accrued but is not yet claimed for one position.",
    icon: "💰",
    category: "Staking",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "stakeIndex", type: "uint256", label: "Stake Index", placeholder: "Enter stake index", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "rewardCycleInfo",
    title: "Reward Cycle Info",
    description: "Read `rewardCycleInfo` from the contract",
    icon: "💰",
    category: "Staking",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => [
      `Total Staked: ${fmt.amount(v.totalStaked ?? v[0])}`,
      `Reward Balance: ${fmt.amount(v.rewardBalance ?? v[1])}`,
    ].join("\n"),
  },
  {
    name: "rewardInterval",
    title: "Reward Interval",
    description: "Read `rewardInterval` from the contract",
    icon: "💰",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "rewardPerStakedToken",
    title: "Reward Per Staked Token",
    description: "Read `rewardPerStakedToken` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "router",
    title: "Router",
    description: "Read `router` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "stakePriceThreshold",
    title: "Stake Price Threshold",
    description: "Read `stakePriceThreshold` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "stakes",
    title: "Stakes",
    description: "Read `stakes` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
      { name: "arg1", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => [
      `Amount: ${fmt.amount(v.amount ?? v[0])}`,
      `Start Time: ${fmt.time(v.startTime ?? v[1])}`,
      `Last Cycle: ${v.lastCycle ?? v[2]}`,
      `Reward Claimed: ${fmt.amount(v.rewardClaimed ?? v[3])}`,
      `Accrued Reward: ${fmt.amount(v.accruedReward ?? v[4])}`,
      `Claim Cycle: ${v.claimCycle ?? v[5]}`,
      `Claimed In Cycle: ${v.claimedInCycle ?? v[6]}`,
      `Burned Amount: ${fmt.amount(v.burnedAmount ?? v[7])}`,
      `Closed: ${fmt.bool(v.closed ?? v[8])}`,
    ].join("\n"),
  },
  {
    name: "totalClaimed",
    title: "Total Claimed",
    description: "Read `totalClaimed` from the contract",
    icon: "🎁",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "totalOwedReward",
    title: "Total Owed Reward",
    description: "Read `totalOwedReward` from the contract",
    icon: "💰",
    category: "Staking",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "stakeIndex", type: "uint256", label: "Stake Index", placeholder: "Enter stake index", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "totalStaked",
    title: "Total Staked",
    description: "Read `totalStaked` from the contract",
    icon: "🔒",
    category: "Staking",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "usdtToken",
    title: "USDT Token",
    description: "Read `usdtToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
];

export const writeFunctions = [
  {
    name: "claimAllDailyRewards",
    title: "Claim All Rewards",
    description: "Claim the pending reward of every stake position you own.",
    icon: "🎁",
    category: "User Actions",
    inputs: [],
  },
  {
    name: "claimDailyReward",
    title: "Claim Daily Reward",
    description: "Claim the pending reward of a single stake position.",
    icon: "🎁",
    category: "User Actions",
    inputs: [
      { name: "stakeIndex", type: "uint256", label: "Stake Index", placeholder: "Enter stake index", required: true, hint: "Use Get User Stakes to find the index (#0, #1, …)." },
    ],
  },
  {
    name: "stake",
    title: "Stake OXY",
    description: "Lock OXY tokens to start earning the daily reward.",
    icon: "🔒",
    category: "User Actions",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether", hint: "OXY is pulled from your wallet — approval happens automatically." },
    ],
    payment: [{ token: "OXY", amount: ({ args }) => args[0] }],
  },
];

export const adminFunctions = [
  {
    name: "addMarketPlaceReward",
    title: "Add Market Place Reward",
    description: "Call `addMarketPlaceReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "addMatrixReward",
    title: "Add Matrix Reward",
    description: "Call `addMatrixReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "newOxyToken", type: "address", label: "New OXY Token", placeholder: "0x…", required: true },
      { name: "nftMarketPlaceContract", type: "address", label: "NFT Market Place Contract", placeholder: "0x…", required: true },
      { name: "newNftMatrixContract", type: "address", label: "New NFT Matrix Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "newSetup",
    title: "New Setup",
    description: "Call `newSetup` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "recoverErc20",
    title: "Recover ERC20",
    description: "Call `recoverErc20` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverErc20All",
    title: "Recover ERC20 All",
    description: "Call `recoverErc20All` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "recoverEth",
    title: "Recover ETH",
    description: "Call `recoverEth` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdt",
    title: "Recover USDT",
    description: "Call `recoverUsdt` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdtAll",
    title: "Recover USDT All",
    description: "Call `recoverUsdtAll` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setMaxClaimAmount",
    title: "Set Max Claim Amount",
    description: "Call `setMaxClaimAmount` on the contract",
    icon: "🎁",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newMaxClaimAmount", type: "uint256", label: "New Max Claim Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setOxyToken",
    title: "Set OXY Token",
    description: "Call `setOxyToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newOxyToken", type: "address", label: "New OXY Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNewNftMarketPlace",
    title: "Set New NFT Market Place",
    description: "Call `setNewNftMarketPlace` on the contract",
    icon: "🛒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMarketPlace", type: "address", label: "New NFT Market Place", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNftMatrixContract",
    title: "Set NFT Matrix Contract",
    description: "Call `setNftMatrixContract` on the contract",
    icon: "🌳",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMatrix", type: "address", label: "New NFT Matrix", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setRouterAndPair",
    title: "Set Router And Pair",
    description: "Call `setRouterAndPair` on the contract",
    icon: "🔁",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newRouter", type: "address", label: "New Router", placeholder: "0x…", required: true },
      { name: "newPair", type: "address", label: "New Pair", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setStakeConfig",
    title: "Set Stake Config",
    description: "Call `setStakeConfig` on the contract",
    icon: "🔒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newStakePriceThreshold", type: "uint256", label: "New Stake Price Threshold", placeholder: "e.g. 10.5", required: true, unit: "ether" },
      { name: "newRewardPerStakedToken", type: "uint256", label: "New Reward Per Staked Token", placeholder: "e.g. 10.5", required: true, unit: "ether" },
      { name: "newRewardInterval", type: "uint256", label: "New Reward Interval", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setTokenApproveMax",
    title: "Set Token Approve Max",
    description: "Call `setTokenApproveMax` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setUsdtToken",
    title: "Set USDT Token",
    description: "Call `setUsdtToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newToken", type: "address", label: "New Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
];

const stakingFunctions = { readFunctions, writeFunctions, adminFunctions };
export default stakingFunctions;
